export default __webpack_public_path__ + "static/media/slider.d40ca598.png";